export default {
  // 説明文 文字数の最小、最大数
  DESCRIPTION_MIN: 1,
  DESCRIPTION_MAX: 400
};
